import { RSAA, RSAAction } from 'redux-api-middleware';

import { EditTppPayload } from './tpps.types';
import * as types from './tppsActionTypes';

export const fetchTpps = (): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: 'tpp-blockades',
    method: 'GET',
    types: [types.FETCH_TPPS_REQUEST, types.FETCH_TPPS_SUCCESS, types.FETCH_TPPS_FAILURE],
  },
});

export const editTpp = (body: EditTppPayload): RSAAction<string, string, string> => ({
  [RSAA]: {
    body,
    endpoint: '/tpp-blockades',
    method: 'PUT',
    types: [types.EDIT_TPP_REQUEST, types.EDIT_TPP_SUCCESS, types.EDIT_TPP_FAILURE],
  },
});
